import React, { ReactNode } from 'react';
import { Modal, IconSvg, helperMargin, Typography, Separator } from '@utex/ui-kit';
import { Content, Wrapper, Footer } from './styles';

export type ResultIconType = 'success' | 'info' | 'fail';

interface Props {
  icon?: ResultIconType;
  title?: string;
  footer?: ReactNode;
  children?: ReactNode;
  onRequestClose: () => void;
  testId?: string;
  backgroungColor?: string;
}

const getResultIcon = (icon?: ResultIconType) => {
  switch (icon) {
    case 'success':
      return 'accept';

    case 'fail':
      return 'decline';

    default:
      return 'info';
  }
};

export const BaseModal = (props: Props) => {
  const { title, footer, children, icon, testId, backgroungColor } = props;

  return (
    <Modal isOpen={true} onRequestClose={props.onRequestClose} testId={testId}>
      <Content backgroungColor={backgroungColor}>
        <Wrapper>
          {title && (
            <>
              {icon && (
                <IconSvg
                  src={getResultIcon(icon)}
                  width={80}
                  height={80}
                  css={helperMargin({ bottom: 20 })}
                />
              )}
              <Typography.Title level={2}>{title}</Typography.Title>
              <Separator />
            </>
          )}
          {children}
        </Wrapper>
        {footer && <Footer>{footer}</Footer>}
      </Content>
    </Modal>
  );
};
